export default __webpack_public_path__ + "static/media/2.ad1db611.png";